

class CustomReadMore extends HTMLElement {
    constructor(){
        super();

        const productDescription = this;
        const readMore = this.nextElementSibling;
        const readMoreDestination = document.getElementById("product_readmore_link");

        if ((productDescription.offsetHeight < productDescription.scrollHeight) || (productDescription.offsetWidth < productDescription.scrollWidth)){
            readMore.style.visibility = "visible";
        }
        else{
            readMore.style.visibility = "hidden";
        }

        readMore.addEventListener("click", function() {
            readMoreDestination.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        });
    }
}
customElements.define('custom-readmore', CustomReadMore);